<mat-icon *ngIf="filteredArtifacts" matTooltip="View Source Artifacts" class="link" [matMenuTriggerFor]="menu" #trigger="matMenuTrigger" (click)="trigger.openMenu()"
  [class.text-success]="!colourOverride"
  [class.text-warning]="colourOverride === 'warning'"
  [class.text-info]="colourOverride === 'info'">grid_view</mat-icon>
<mat-menu #menu="matMenu">
  <ng-container *ngFor="let group of filteredArtifacts">
    <div class="w-100 text-center">
      <small [class.light]="!isDarkMode" [class.dark]="isDarkMode">{{ group.groupKey }}</small>
    </div>
    <ng-container *ngFor="let artifact of group.artifacts">
      <button mat-menu-item [disabled]="!artifact.isClickable" [routerLink]="artifact.routes" [queryParams]="artifact.queryParams">
        <small>{{ artifact.displayText }} <span class="text-info">v{{ artifact?.version }}</span></small>
      </button>
    </ng-container>
  </ng-container>
</mat-menu>